interface Props {
  label: string;
  value: number | string;
  hint?: string | undefined;
  emphasis?: 'default' | 'warn';
  loading?: boolean;
}

export function KpiCard({ label, value, hint, emphasis = 'default', loading = false }: Props) {
  return (
    <div className="panel p-6">
      <div className="label">{label}</div>
      <div
        className={`mt-3 font-light tracking-tight ${
          emphasis === 'warn' ? 'text-red-400' : 'text-ink-50'
        } text-kpi tabular-nums`}
      >
        {loading ? <span className="text-ink-700">—</span> : value}
      </div>
      {hint ? <div className="mt-2 text-xs text-ink-500">{hint}</div> : null}
    </div>
  );
}
